import {createTheme} from "@mui/material/styles";

export const theme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    cursor: 'pointer',
                    '&.Mui-disabled': {
                        cursor: 'not-allowed',
                        pointerEvents: 'auto',
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled, &.Mui-disabled .MuiInputBase-input, &.Mui-disabled .MuiSelect-select': {
                        cursor: 'not-allowed',
                    },
                },
            },
        },
    },
    // components: {
    //     MuiButton: {
    //         styleOverrides: {
    //             root: {
    //                 boxShadow: 'none',
    //             },
    //             contained:{
    //                 backgroundColor: CommonThemeColors.sys.light.secondary,
    //             }
    //         },
    //     },
    //     MuiAvatar: {
    //         styleOverrides: {
    //             root: {
    //                 backgroundColor: CommonThemeColors.sys.components.avatar.fill
    //             },
    //         },
    //     },
    // },
    //
    //
    // palette: {
    //     primary: {
    //         main: CommonThemeColors.sys.primary.main,
    //         dark: CommonThemeColors.sys.primary.dark,
    //         light: CommonThemeColors.sys.primary.light,
    //         "contrastText": CommonThemeColors.sys.primary.contrast,
    //     },
    //     secondary: {
    //         main: CommonThemeColors.sys.secondary.main,
    //         dark: CommonThemeColors.sys.secondary.dark,
    //         light: CommonThemeColors.sys.secondary.light,
    //         contrastText: CommonThemeColors.sys.secondary.contrast,
    //     },
    //     error: {
    //         main: CommonThemeColors.sys.error.main,
    //         dark: CommonThemeColors.sys.error.dark,
    //         light: CommonThemeColors.sys.error.light,
    //         contrastText: CommonThemeColors.sys.error.contrast,
    //     },
    //     warning: {
    //         main: CommonThemeColors.sys.warning.main,
    //         dark: CommonThemeColors.sys.warning.dark,
    //         light: CommonThemeColors.sys.warning.light,
    //         contrastText: CommonThemeColors.sys.warning.contrast,
    //     },
    //     info: {
    //         main: CommonThemeColors.sys.info.main,
    //         dark: CommonThemeColors.sys.info.dark,
    //         light: CommonThemeColors.sys.info.light,
    //         contrastText: CommonThemeColors.sys.info.contrast,
    //     },
    //     success: {
    //         main: CommonThemeColors.sys.success.main,
    //         dark: CommonThemeColors.sys.success.dark,
    //         light: CommonThemeColors.sys.success.light,
    //         contrastText: CommonThemeColors.sys.success.contrast,
    //     },
    //     text: {
    //         primary: CommonThemeColors.sys.text.primary,
    //         secondary: CommonThemeColors.sys.text.secondary,
    //         disabled: CommonThemeColors.sys.text.disabled,
    //     }
    // },
    typography: {
        h1: {
            textAlign: 'start',
            fontSize: '60px',
            fontWeight: 300,
            "@media print": {
                fontSize: '1.4em'
            }
        },
        h2: {
            textAlign: 'start',
            fontSize: '48px',
            fontWeight: 300,
            "@media print": {
                fontSize: '1.2em'
            }
        },
        h3: {
            textAlign: 'start',
            fontSize: '34px',
            fontWeight: 400,
            "@media print": {
                fontSize: '1.0em'
            }
        },
        h4: {
            textAlign: 'start',
            fontSize: '24px',
            fontWeight: 400,
            "@media print": {
                fontSize: '0.9em'
            }
        },
        h5: {
            textAlign: 'start',
            fontSize: '20px',
            fontWeight: 400,
            "@media print": {
                fontSize: '0.7em'
            }
        },
        h6: {
            textAlign: 'start',
            fontSize: '16px',
            fontWeight: 500,
            "@media print": {
                fontSize: '0.7em'
            }
        },
        subtitle1: {
            textAlign: 'start',
            fontSize: '14px',
            lineHeight: '14px',
            fontWeight: 400,
            "@media print": {
                fontSize: '0.6em'
            }
        },
        subtitle2: {
            textAlign: 'start',
            fontSize: '12px',
            lineHeight: '12px',
            fontWeight: 500,
            "@media print": {
                fontSize: '0.6em'
            }
        },
        body1: {
            textAlign: 'start',
            fontSize: '14px',
            lineHeight: '16px',
            fontWeight: 400,
            "@media print": {
                fontSize: '0.7em'
            }
        },
        body2: {
            textAlign: 'start',
            fontSize: '12px',
            lineHeight: '14px',
            fontWeight: 400,
            "@media print": {
                fontSize: '0.6em'
            }
        },
        caption: {
            textAlign: 'start',
            fontSize: '10px',
            lineHeight: '10px',
            fontWeight: 400,
            "@media print": {
                fontSize: '0.5em'
            }
        },
        button: {
            // textTransform: 'none',
            fontSize: '14px',
            fontWeight: 500,
            "@media print": {
                fontSize: '0.6em'
            }
        }
    },
});
